<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex xs4 offset-xs4>
                <div class="form-group dropbox">
                  <input type="file" @change="onFileChanged" class="input-file" />
                  <p v-if="!product.imageUrl">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                  <img v-if="product.imageUrl" :src="product.imageUrl" />
                </div>
              </v-flex>
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Name"
                  v-model="product.name"
                  type="text"
                  :rules="rules.productNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Product Code"
                  v-model="product.code"
                  type="text"
                  :rules="rules.codeRules"
                  :readonly="canEditCodeDisabled"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="color"
                  label="Product Color"
                  v-model="product.color"
                  type="text"
                  :rules="rules.colorRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="product.brandName"
                  :items="brandList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Brand..."
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  :rules="rules.brandRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="product.categoryName"
                  :items="categoryList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Category..."
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  :rules="rules.categoryRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="product.productGroupName"
                  :items="productGroupList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Product Group..."
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                name="reorderQty"
                label="Reorder Level"
                v-model="product.reorderQty"
                type="number"
                min="0"
                :rules="rules.reorderQtyRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Product Description"
                  v-model="product.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="product.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="product.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="product.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="product.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="product.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="product.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addProductUnit()">
                    Add Unit
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-flex v-for="(productUnit, index) in product.productUnits"
                  :key="index">
                <v-layout row wrap class="light--text">
                  <v-flex xs1>Factor</v-flex>
                  <v-flex xs1>Unit</v-flex>
                  <v-flex xs1>Basic</v-flex>
                  <v-flex xs1>Purchase</v-flex>
                  <v-flex xs1>Sale</v-flex>
                  <v-flex xs2>Barcode</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                 <v-sheet
          class="pa-2"
          color="grey lighten-3"
        >
                <v-layout 
                  row
                  wrap
                >
                  <v-flex xs1 v-if="productUnit.factor === 1">
                    <v-text-field
                      v-model="productUnit.factor"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-text-field
                      v-model="productUnit.factor"
                      type="number"
                      min="0"
                      :rules="rules.factorRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-autocomplete
                      v-model="productUnit.unitName"
                      :items="unitList"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-text="name"
                      item-value="name"
                      menu-props="auto"
                      label="Select"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1 v-if="productUnit.basicUnit">
                    <v-checkbox v-model="productUnit.basicUnit" readonly></v-checkbox>
                  </v-flex>
                  <v-flex xs1 v-else></v-flex>
                  <v-flex xs1 v-if="productUnit.factor === 1">
                    <v-checkbox v-model="productUnit.purchaseUnit" readonly></v-checkbox>
                  </v-flex>
                     <v-flex xs1 v-else>
                    <v-checkbox v-model="productUnit.purchaseUnit"></v-checkbox>
                  </v-flex>
                   <v-flex xs1 v-if="productUnit.factor === 1">
                    <v-checkbox v-model="productUnit.saleUnit" readonly></v-checkbox>
                  </v-flex>
                    <v-flex xs1 v-else>
                    <v-checkbox v-model="productUnit.saleUnit"></v-checkbox>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field v-model="productUnit.barcode" :rules="rules.barcodeRules"></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-if="productUnit.factor !== 1">
                    <v-btn icon @click="removeProductUnit(index, productUnit.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-btn icon @click="removeProductUnit(index, productUnit.id)" disabled>
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 offset-xs1>
                <v-layout row wrap>
                  <v-flex sm2>
                <v-btn color="success" @click="addPrice(index)">
                    Add Price
                    <v-icon right>add</v-icon>
                </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs2>Currency</v-flex>
                  <v-flex xs2>Buy Price</v-flex>
                  <v-flex xs2>Unit Cost</v-flex>
                  <v-flex xs2>Selling Price</v-flex>
                  <v-flex xs2>Wholesale Price</v-flex>
                  <v-flex xs1></v-flex>
                </v-layout>
                <v-layout row wrap v-for="(productUnitPrice, point) in productUnit.productUnitPriceList"
                  :key="point">
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="productUnitPrice.currencyId"
                      :items="currencyList"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-text="code"
                      item-value="id"
                      menu-props="auto"
                      label="Select"
                      :rules="rules.currencyRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="Buy Price"
                      v-model="productUnitPrice.buyingPrice"
                      type="number"
                      min="0"
                      :rules="rules.buyingPriceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="Unit Cost"
                      v-model="productUnitPrice.unitCost"
                      type="number"
                      min="0"
                      :rules="rules.unitCostRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="productUnitPrice.sellingPrice"
                      type="number"
                      min="0"
                      :rules="rules.sellingPriceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="productUnitPrice.wholesalePrice"
                      type="number"
                      min="0"
                      :rules="rules.wholesalePriceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 v-if="point == 0">
                    <v-btn icon @click="removePrice(index, point, productUnitPrice.id)" disabled>
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 v-else>
                    <v-btn icon @click="removePrice(index, point, productUnitPrice.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                  </v-flex>
                </v-layout>
                 </v-sheet>
                </v-flex>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import { currencyService } from "../../services/currency-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { productGroupService } from "../../services/product-group-service";
import { unitService } from "../../services/unit-service";
import { Product } from "../../models/model";
import { ProductUnit, ProductUnitPrice } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { ProductFormRules } from "../../helpers/validation-rules";
export default {
  name: "ProductDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Product",
        disabled: false,
        to: "products"
      },
      {
        text: "Product Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    product: new Product(),
    oldProduct: new Product(),
    productUnit: new ProductUnit(),
    productUnitPrice: new ProductUnitPrice(),
    statusFlag: true,
    saveLoading: false,
    canEditCodeDisabled: true,
    responseError: "",
    rules: new ProductFormRules(),
    brandList: [],
    categoryList: [],
    productGroupList: [],
    unitList: [],
    currencyList: [],
  }),
  created() {
    this.getBrands();
    this.getActiveCurrency();
    this.getCategories();
    this.getProductGroups();
    this.getUnits();
    const id = this.$route.params.id;
    if (id == "new") {
      // new product
      this.canEditCodeDisabled = false;
      this.initProductUnit();
    } else {
      if (this.user.roleName == "ADMIN" && this.user.username == "sysadmin") {
        this.canEditCodeDisabled = false;
      }
      this.getProductDetail(id);
    }
  },
  methods: {
    getBrands() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveCurrency(){
    currencyService.getCurrencyByStatus("ACTIVE")
    .then(res => {
    if(res.data){
      this.currencyList = res.data;
    }
    })
    .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getCategories() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getProductGroups() {
      productGroupService
        .getAllProductGroup()
        .then(res => {
          this.productGroupList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getUnits() {
      unitService
        .getUnitsByStatus("ACTIVE")
        .then(res => {
          this.unitList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.product.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        var str = this.product.code;
        var code = str.replace(/\s/g, "");
        this.product.code = code;
        productService
          .saveProduct(this.product)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getProductDetail(id) {
      productService
        .getProductDetail(id)
        .then(res => {
          this.product = res.data;
          this.product.color = this.product.color ? this.product.color : "";
          if (!this.product.name2) this.product.name2 = "";
          this.categoryList.push(res.data.category);
          this.productGroupList.push(res.data.productGroup);
          this.brandList.push(res.data.brand);
          
          this.createdDate = commonService.formatDate(
            new Date(this.product.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          
          this.updatedDate = commonService.formatDate(
            new Date(this.product.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldProduct = JSON.parse(JSON.stringify(res.data));

          this.statusFlag = this.product.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.product.id) {
        this.product = new Product();
        this.statusFlag = true;
        this.initProductUnit();
      } else {
        this.product = Object.assign({}, this.oldProduct);
        this.statusFlag = this.product.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/products");
    },
    initProductUnit() {
      // deep copy
      let pu = JSON.parse(JSON.stringify(this.productUnit));
      pu.factor = 1;
      pu.basicUnit = true;
      pu.purchaseUnit = true;
      pu.saleUnit = true;
      let puprice = JSON.parse(JSON.stringify(this.productUnitPrice));
      pu.productUnitPriceList.push(puprice);
      this.product.productUnits.push(pu);
    },
    addProductUnit() {
      // deep copy
      let pu = JSON.parse(JSON.stringify(this.productUnit));
      let puprice = JSON.parse(JSON.stringify(this.productUnitPrice));
      pu.productUnitPriceList.push(puprice);
      this.product.productUnits.push(pu);
    },

    addPrice(index){
      let puprice = JSON.parse(JSON.stringify(this.productUnitPrice));
      this.product.productUnits[index].productUnitPriceList.push(puprice);
    },

    removePrice(index, point, productUnitPriceId) {
      if(productUnitPriceId){
        if(!this.product.productUnits[index].deleteProductUnitPriceIds){
          this.product.productUnits[index].deleteProductUnitPriceIds = [];
        }
        this.product.productUnits[index].deleteProductUnitPriceIds.push(productUnitPriceId);
      }
      this.$delete(this.product.productUnits[index].productUnitPriceList, point);
    },
    
    removeProductUnit(index, productUnitId) {
      if (productUnitId) {
        // add delete product unit id
        if (!this.product.deleteProductUnitIds) {
          this.product.deleteProductUnitIds = [];
        }
        this.product.deleteProductUnitIds.push(productUnitId);
      }
      this.$delete(this.product.productUnits, index);
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.product.imageUrl = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then(data => {
        this.product.image = data;
      });
    }
  }
};
</script>

